import { DEFAULT_ASPECT_RATIO, ROUND_CORNERS } from './constants';
export const getAspectRatio = ({ height, width, }) => (width && height ? width / height : DEFAULT_ASPECT_RATIO);
export const getAspectRatioForEmbed = ({ height, thumbnail_height: thumbnailHeight, thumbnail_width: thumbnailWidth, width, }) => getAspectRatio({
    height: height !== null && height !== void 0 ? height : thumbnailHeight,
    width: width !== null && width !== void 0 ? width : thumbnailWidth,
});
export const extractWebsite = (url) => {
    const matches = url === null || url === void 0 ? void 0 : url.match(/https?:\/\/(?:www\.)?([^\\/]+)/u);
    if (matches) {
        return matches[1];
    }
    return url;
};
export const getProviderName = ({ provider_name: providerName, provider_url: providerUrl, url, }) => capitalize(providerName || extractWebsite(providerUrl) || extractWebsite(url) || '');
export const capitalize = (str) => str ? str[0].toUpperCase() + str.slice(1) : str;
export const normalizeType = (type) => String(type !== null && type !== void 0 ? type : '').toLowerCase();
export const borderRadius = ({ $rounded, theme, }) => {
    const value = ROUND_CORNERS[$rounded];
    if (value === ROUND_CORNERS.themeDefault) {
        return theme.themeVariables.globalBorderRadius;
    }
    return value;
};
//# sourceMappingURL=utils.js.map